<template>
  <div class="col-7">
    <el-card>
      <div style="display: flex" class="sales-title">
        <h4 style="display: inline">Sales</h4>
        <h4 style="order: 2; margin-left: auto" class="sub">
          Effective Date :
          {{ formatter_date(Sales.effectiveDate, 'DD/MM/YYYY') }}
        </h4>
        <h4 style="order: 3" class="sub">
          <el-button
            link
            @click="recordDialogVisible = true"
            style="font-size: 11px; color: #3182ce; padding: 0"
            class="change-link"
            :disabled="!bEnableChangeHistory"
          >
            <i class="tim-icons icon-notes"></i> Change History</el-button
          >
        </h4>
        <h4 style="order: 4" class="sub">
          <el-button
            link
            @click="ShowChangeActionDialog()"
            style="font-size: 11px; color: #3182ce; padding: 0"
            class="change-link"
            :disabled="!ChangeActionPermission()"
          >
            <i class="tim-icons icon-single-02"></i> Change Action</el-button
          >
        </h4>
      </div>
      <div style="display: flex; justify-content: space-between">
        <base-input label="Salesman">
          <el-select
            class="select-primary"
            size="large"
            v-model="Sales.salesmanCode"
            placeholder="Salesman"
            filterable
            :disabled="SalesmanDisabled()"
            :class="{ 'is-error': !OrderRules.salesman.validation }"
            @change="useOrder.changeSalesman"
          >
            <el-option
              class="select-primary"
              v-for="item in SalesmanOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </base-input>
        <base-input label="Team Head" v-model="Sales.teamHead" :disabled="true">
        </base-input>
        <base-input
          label="Sale Head"
          v-model="Sales.salesHead"
          :disabled="true"
        >
        </base-input>
        <base-input label="Pool Head" v-model="Sales.poolHead" :disabled="true">
        </base-input>
      </div>
    </el-card>
  </div>
  <div class="col-5">
    <el-card>
      <div class="row">
        <div class="col-7">
          <el-descriptions :column="2">
            <el-descriptions-item label="Order No:" :span="2">
              {{ Order.orderNumber }}
            </el-descriptions-item>
            <el-descriptions-item :span="2">
              <template #label>
                <span>
                  <el-icon class="icon-shape-left">
                    <svg-icon iconClass="shape-left"></svg-icon
                  ></el-icon>
                  Status:</span
                >
              </template>
              {{ Order.status }}
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="2">
            <el-descriptions-item>
              <template #label>
                <span>
                  <el-icon class="icon-shape-left">
                    <svg-icon iconClass="shape-left"></svg-icon
                  ></el-icon>
                  Create By:</span
                >
              </template>
              {{ Order.createByName }}
            </el-descriptions-item>
            <el-descriptions-item label="Date">
              {{ formatter_datetime(Order.createDate) }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <span>
                  <el-icon class="icon-shape-left">
                    <svg-icon iconClass="shape-left"></svg-icon
                  ></el-icon>
                  Update By:</span
                >
              </template>
              {{ Order.updateByName }}
            </el-descriptions-item>
            <el-descriptions-item label="Date">
              {{ formatter_datetime(Order.updateDate) }}
              <el-button
                link
                style="font-size: 18px"
                @click="refreshDate"
                v-if="
                  useOrder.getOrderFunctionPermission('RefreshDate')?.enable
                "
                :disabled="
                  useOrder.getOrderFunctionPermission('RefreshDate')?.disable
                "
                ><el-icon> <refresh /> </el-icon
              ></el-button>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="col-5">
          <div class="alert-message" v-if="AlertMessages.length > 0">
            <div style="height: 115px">
              <el-scrollbar>
                <div
                  style="word-wrap: break-word"
                  v-for="(item, index) in AlertMessages"
                  :key="index"
                >
                  <div style="padding-right: 5px">
                    <el-icon style="color: #979797">
                      <ChatLineRound />
                    </el-icon>
                    Alert Message: {{ item }}
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
  <div class="update-salesman-dialog" v-if="salesmanDialogVisible">
    <update-salesman-dialog
      v-model="salesmanDialogVisible"
      :disabled="!ChangeActionPermission()"
    />
  </div>
  <div class="update-history-dialog" v-if="recordDialogVisible">
    <update-history-dialog v-model="recordDialogVisible" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import { ChatLineRound, Refresh } from '@element-plus/icons-vue';
import UpdateSalesmanDialog from './UpdateSalesman';
import UpdateHistoryDialog from './UpdateHistory';
import { formatter_date, formatter_datetime } from '@/assets/js/formatter.js';
import { useOrderStore } from '@/store/order';
import { useAuthorityStore } from '@/store/authority';
import { storeToRefs } from 'pinia';
import { ElMessage } from 'element-plus';

const useAuthority = useAuthorityStore();
const useOrder = useOrderStore();
const {
  Order,
  OrderRules,
  Sales,
  disabled,
  AlertMessages,
  // bEnableChangeAction,
  // EnableChangeActionMessage,
  bEnableChangeHistory,
  SalesOption,
} = storeToRefs(useOrder);

// 开关
const recordDialogVisible = ref(false);
const refreshDialogVisible = ref(false);
const ChangeDisabled = ref(true);
const RefreshRef = ref();
const salesmanDialogVisible = ref(false);
const SalesmanOptions = ref([]);

const ChangeActionFunction = ref({
  disabled: false,
  message: '',
});

const emit = defineEmits(['refresh']);

onMounted(() => {
  var SalesList = useOrder.getSalesList();

  if (SalesList.length > 0) {
    var sales = SalesList.map((t) => {
      return { value: t.salesmanCode, label: t.salesman };
    });

    SalesmanOptions.value = sales.filter(
      (item, index) => sales.findIndex((i) => i.value == item.value) === index
    );
  }
});
//是否可以修改salesman
const SalesmanDisabled = () => {
  // Super Admin可以任何時候除Order Void及Completed不是便可以改
  if (
    useAuthority.GetAuthority('SuFunction_AllUpdateSalesman') &&
    !disabled.value &&
    useOrder.OrderStatus != 'Completed' &&
    useOrder.OrderStatus != 'Void'
  ) {
    return false;
  }
  return disabled.value || useOrder.SalesmanDisabled;
};

// event: 更新Salesman
const updateSalesman = async () => {
  const validMsg = RefreshRef.value.ValidRequire();
  if (validMsg !== '') {
    ElMessage({
      message: validMsg,
      type: 'error',
    });
    return;
  }

  // 更新Salesman信息
  await RefreshRef.value
    .updateEvent()
    .then((res) => res)
    .catch((err) => {
      ElMessage({ message: err, type: 'error' });
    });

  // 重载
  refreshDialogVisible.value = false;
};

// formatter：格式化
const formatter = (val) => {
  console.log('val', val);
  if ((val || '') === '') {
    return '-';
  }
  return val;
};

const isOrderTop = () => {
  const useAuthority = useAuthorityStore();
  return useAuthority.isOrderTop();
};

const ChangeActionPermission = () => {
  return !useOrder.getOrderFunctionPermission('ChangeAction')?.disable;
};
const ShowChangeActionDialog = () => {
  var message =
    useOrder.getOrderFunctionPermission('ChangeAction')?.disabledMessage;
  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return false;
  }
  salesmanDialogVisible.value = true;
};

const refreshDate = () => {
  emit('refresh');
};
</script>

<style scoped>
.new-order h4 {
  color: #3b291d;
}

.new-order h5 {
  color: #423022;
}

.sales-title h4.sub {
  margin-left: 54px;
  display: inline-block;
  font-size: 11px;
}

.sales-title i {
  position: relative;
  top: -1px;
  right: 4px;
}

.new-order .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 6px;
}

.advertiser-field .form-group.has-label label::after {
  content: '【 Contracting Party 】';
  color: #d05c5f;
}

.sub-info {
  font-size: 10px;
  color: #9a9a9a;
  margin-left: 30px;
}

.sub-info .dot {
  width: 5px;
  height: 5px;
  background-color: rgb(169, 169, 169);
  display: inline-block;
  border-radius: 50%;
  top: -1px;
  position: relative;
  right: 2px;
}

.Rectangle {
  width: 160px;
  height: 32px;
  margin: 20px 1474.6px 0 0;
  padding: 6px 15px 6px 58px;
  border-radius: 6px;
  background-image: linear-gradient(to left, #eb6100, #b60005);
  color: #fff;
}

.alert-message {
  background: #f5f5f5;
  padding: 10px;
  height: 100%;
  border-radius: 15px;
}

.change-link:disabled {
  opacity: 0.5;
}
</style>
<style>
.icon-shape-left {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  padding: 3.5px 3px 3.9px 2.8px;
  background-color: #fe9350;
}
</style>
